function statusLabel(status) {
    if (status === 'ACTIVE')
        return 'В программе';
    if (status === 'COMPLETED')
        return 'Программа пройдена';
    return 'Снят с программы';
}
export function formatEngagementStatus(status) {
    return statusLabel(status);
}
export function formatCardMetricValue(key, card) {
    const raw = card.metrics?.[key];
    if (key === 'fullName') {
        return card.agentDisplayName;
    }
    if (key === 'status') {
        return statusLabel(card.status);
    }
    if (key === 'visitedProjectCount') {
        return String(raw ?? card.visitedProjectCount);
    }
    if (typeof raw === 'boolean') {
        return raw ? 'Да' : 'Нет';
    }
    if (raw == null || raw === '') {
        return '—';
    }
    if (key === 'lastNoticeAt' && typeof raw === 'string') {
        const date = new Date(raw);
        return Number.isNaN(date.getTime())
            ? raw
            : date.toLocaleDateString('ru-RU');
    }
    return String(raw);
}
const SKIP_SUMMARY_KEYS = new Set(['fullName', 'status']);
/** Short secondary line for a kanban card. */
export function cardSummaryLine(card, metrics) {
    const preferred = metrics.find((metric) => metric.key === 'visitedProjectCount') ??
        metrics.find((metric) => !SKIP_SUMMARY_KEYS.has(metric.key) &&
            card.metrics?.[metric.key] != null);
    const metric = preferred ??
        metrics.find((item) => !SKIP_SUMMARY_KEYS.has(item.key));
    if (!metric) {
        if (card.visitedProjectCount > 0) {
            return `Посетил проектов: ${card.visitedProjectCount}`;
        }
        return null;
    }
    if (metric.key === 'visitedProjectCount') {
        return `Посетил проектов: ${formatCardMetricValue(metric.key, card)}`;
    }
    const value = formatCardMetricValue(metric.key, card);
    if (value === '—') {
        return null;
    }
    return `${metric.label}: ${value}`;
}
